export const generateSessionCode = (): string => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};

export const getPriceLevelString = (level: number): string => {
  switch (level) {
    case 1: return '$';
    case 2: return '$$';
    case 3: return '$$$';
    case 4: return '$$$$';
    default: return '$$';
  }
};

export const getCuisineEmoji = (cuisine: string): string => {
  const lower = cuisine.toLowerCase();
  if (lower.includes('pizza')) return '🍕';
  if (lower.includes('burger') || lower.includes('american')) return '🍔';
  if (lower.includes('mexican') || lower.includes('taco')) return '🌮';
  if (lower.includes('chinese')) return '🥡';
  if (lower.includes('japanese') || lower.includes('sushi')) return '🍣';
  if (lower.includes('thai')) return '🍜';
  if (lower.includes('indian')) return '🍛';
  if (lower.includes('italian')) return '🍝';
  if (lower.includes('mediterranean') || lower.includes('greek')) return '🥙';
  if (lower.includes('bbq') || lower.includes('barbecue')) return '🍖';
  if (lower.includes('seafood') || lower.includes('fish')) return '🦞';
  if (lower.includes('sandwich') || lower.includes('deli')) return '🥪';
  if (lower.includes('breakfast') || lower.includes('brunch')) return '🍳';
  if (lower.includes('salad') || lower.includes('healthy')) return '🥗';
  if (lower.includes('korean')) return '🥩';
  if (lower.includes('vietnamese')) return '🍲';
  return '🍽️';
};

export const formatRating = (rating: number): string => {
  return rating.toFixed(1);
};